// extracted by mini-css-extract-plugin
export default {"transparent":"wgeqidkB_Y3Lp75ADnQh","icon-transition":"CTJHMBdUi_CvQaUp8BKl","arrow-position":"BVEMU7rhhwCqUwpV4eOG","rotate-icon":"SaQBsLaN3QXzclV_ANwy"};